<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path fill="#E1F5FE" d="M0 0L7.334 0 7.333 17.797 3.667 21.463 0 17.797z" transform="translate(-157 -621) translate(127 490) translate(16 66) translate(0 50) translate(14 15) translate(1 1)" />
                  <path fill="#164194" d="M10.083 0L10.083 1.834 14.327 1.834 20.166 6.838 20.166 20.167 8.25 20.167 8.25 22 22.001 22 22.001 5.995 15.006 0z" transform="translate(-157 -621) translate(127 490) translate(16 66) translate(0 50) translate(14 15) translate(1 1)" />
                  <path fill="#164194" d="M17.417 7.333L13.75 7.333 13.75 0.917 15.583 0.917 15.583 5.5 17.417 5.5z" transform="translate(-157 -621) translate(127 490) translate(16 66) translate(0 50) translate(14 15) translate(1 1)" />
                  <path
                    fill="#13A2E8"
                    d="M0 5.5h7.333V0H0v5.5zm1.833-1.833h3.668V1.833H1.833v1.834zM5.5 7.333L5.5 17.037 3.666 18.871 1.833 17.037 1.833 7.333 0 7.333 0 17.797 3.666 21.463 7.334 17.797 7.334 7.333z"
                    transform="translate(-157 -621) translate(127 490) translate(16 66) translate(0 50) translate(14 15) translate(1 1)"
                  />
                  <path fill="#13A2E8" d="M2.75 15.583L4.583 15.583 4.583 4.583 2.75 4.583z" transform="translate(-157 -621) translate(127 490) translate(16 66) translate(0 50) translate(14 15) translate(1 1)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>